import { createContext, useState } from 'react'

const RegisterContext = createContext()

export const RegisterProvider = ({ children }) => {
    // variables to save credential information
   const [credentials, setCredentials] = useState({
      first: '',
      last: '',
      username: '',
      email: '',
      password: '',
   })

   // variable to track user status
   const [user, setUser] = useState(false);
   // variable to track password matching
   const [noMatch, setNoMatch] = useState(false);
   // boolean to track password length
   const [short, setShort] = useState(false);
   // boolean to track unique username
   const [unique, setUnique] = useState(false);

   return <RegisterContext.Provider value = {{
      credentials,
      setCredentials,
      user, 
      setUser,
      noMatch,
      setNoMatch,
      short,
      setShort,
      unique,
      setUnique
   }}>
      {children}
   </RegisterContext.Provider>
}

export default RegisterContext